import { SPRK_URL } from "@/lib/ascentix";

export default function SprkBadge() {
  return (
    <a
      href={SPRK_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sprk-badge"
      aria-label="Designed by SPRK"
      className="hidden md:inline-flex fixed left-5 bottom-5 z-30 items-center gap-2.5 px-4 py-2.5 rounded-full bg-white/90 backdrop-blur-md border border-slate-900/10 text-[13px] font-medium text-slate-700 hover:text-slate-900 hover:border-slate-900/30 hover:shadow-lg transition-all duration-300"
    >
      <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">
        Designed by
      </span>
      <span className="font-display tracking-[0.32em] text-slate-900 text-[14px]">
        SPRK
      </span>
      <span className="size-1.5 rounded-full bg-orange-500" />
    </a>
  );
}
